import fetch, { NewAxiosRequestConfig } from '@/utils/axios';
import { isRobot } from '@/utils/common/device';

/**
 * 获取experiment列表
 */
export const getExperimentList = (
  params: {
    user_id: string;
    device_id: string;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/data/experiment/settings/list`, params, config);
};

/**
 * 加入experiment whiteList
 */
export const joinExperimentWhiteList = (params, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post(`/data/experiment/settings/whitelist/add`, params, config);
};

/**
 * 切换experiment
 */
export const switchExperiment = (params, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post(`/data/experiment/settings/switch`, params, config);
};

type ExperimentResponse = {
  experiment_id: number;
  experiment_status?: 'IN_PROGRESS' | 'FINISHED' | 'CLOSED';
  has_joined_experiment?: boolean;
  // 分组key，在同一个实验中不同的组的key具有唯一性
  routed_group_key?: string;
  //1-实验组，2-对照组
  routed_group_variation: string;
};

/**
 * 试验新接口
 * @param params
 * @param config
 * @returns
 */
export const getABExperimentResult = (
  params: { experiment_id: number; percent?: number } & ObjectType,
  config?: NewAxiosRequestConfig
): Promise<AResponse<ExperimentResponse>> => {
  //是爬虫的情况下不需要调用试验接口
  if (isRobot(config?.ctx)) {
    return Promise.resolve({
      result: true,
      message: '',
      message_id: '10000',
      object: {
        routed_group_variation: '2'
      }
    } as AResponse<ExperimentResponse>);
  }
  return fetch.post(`/data/experiment/group/v2/record`, params, config);
};
